import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, MapPin, Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function CTASection() {
  const {
    lang
  } = useLanguage();
  return <section id="contacto" className="relative py-[120px] text-center overflow-hidden bg-gradient-to-br from-inkova-dark-purple via-inkova-primary to-[#8B5CF6]" data-id="element-88" data-mp="2ceyukh07xgem">
      {/* Decorative background element */}
      <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(circle_at_60%_40%,rgba(192,132,252,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-89" data-mp="2mdo4nnlvhwkb" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-90" data-mp="2v7j6omrp76vq">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-91" data-mp="305kqxb0v1c8s">
          <h2 className="text-[32px] sm:text-[4vw] lg:text-[52px] font-serif text-white leading-[1.2] mb-5" data-id="element-92" data-mp="2179u2te2avb1">
            {lang === 'es' ? 'Visualízalo. Pero esta vez, acciona.' : 'Visualize it. But this time, take action.'}
          </h2>

          <p className="text-[17px] text-white/80 max-w-[580px] mx-auto leading-[1.75] mb-12" data-id="element-93" data-mp="1n6qlnl5opn8c">
            {lang === 'es' ? 'Tu negocio digital con propósito no va a construirse solo. El primer paso es el más importante — y el más sencillo.' : 'Your digital business with purpose is not going to build itself. The first step is the most important — and the simplest.'}
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-14" data-id="element-94" data-mp="2664jwfag5k4n">
            <a href="https://inkovacreation.store/shop/341dc5f2-2e37-4bec-89a7-31063f77eefd" target="_blank" rel="noopener noreferrer" className="inline-flex flex-col items-center bg-gradient-to-br from-white to-[#F3EEFA] text-inkova-primary px-9 py-4 rounded-full font-bold text-[15px] shadow-[0_8px_32px_rgba(255,255,255,0.25)] hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-[0_16px_48px_rgba(255,255,255,0.4)] transition-all duration-300" data-id="element-95" data-mp="32n7hv5rt8r5f">
              {lang === 'es' ? 'DA EL PRIMER PASO' : 'TAKE THE FIRST STEP'}
              <small className="text-[11px] font-normal opacity-70 mt-1" data-id="element-96" data-mp="d8h2xu5eonuu">
                {lang === 'es' ? 'Sesión Diagnóstico · $50 · 30 minutos' : 'Diagnostic Session · $50 · 30 minutes'}
              </small>
            </a>

            <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center border-[1.5px] border-white/60 text-white px-8 py-4 rounded-full font-medium text-[15px] hover:bg-white/10 hover:border-white hover:scale-[1.02] transition-all duration-300" data-id="element-97" data-mp="3bul7e8dmcx1">
              {lang === 'es' ? 'Tengo una pregunta → WhatsApp' : 'I have a question → WhatsApp'}
            </a>
          </div>

          <hr className="border-t border-white/20 max-w-[400px] mx-auto mb-10" data-id="element-98" data-mp="plgpskzhaxi" />

          <div className="flex flex-wrap justify-center gap-6 sm:gap-12" data-id="element-99" data-mp="roi18rl6qhj">
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-100" data-mp="3s38059pxuwby">
              <Sparkles className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-101" data-mp="9pi6xyn0uhuo" />
              {lang === 'es' ? '100+ negocios construidos' : '100+ businesses built'}
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-102" data-mp="ep4ouldsom9t">
              <MapPin className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-103" data-mp="2lg2pzd3jsoew" />
              Miami, Florida
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-104" data-mp="2gj3zd4j3ezlg">
              <Globe className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-105" data-mp="2hxn3qb0nu0ho" />
              {lang === 'es' ? 'Para emprendedores en cualquier parte del mundo' : 'For entrepreneurs anywhere in the world'}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}